<div class="empresa-selecao">
  <ul class="empresa-lista" role="list">
    <li *ngFor="let empresa of empresas">
      <button
        type="button"
        class="empresa-item"
        [disabled]="!!loadingRef"
        [attr.aria-busy]="loadingRef === empresa.ref ? 'true' : null"
        (click)="onEscolher(empresa.ref)"
      >
        <i
          class="pi empresa-item-icon"
          [ngClass]="loadingRef === empresa.ref ? 'pi-spin pi-spinner' : 'pi-envelope'"
          aria-hidden="true"
        ></i>
        <span class="empresa-item-textos">
          <span class="empresa-item-destino">{{ empresa.destinoMascarado }}</span>
          <span class="empresa-item-nome" *ngIf="empresa.nome">{{ empresa.nome }}</span>
        </span>
        <i class="pi pi-chevron-right empresa-item-arrow" *ngIf="loadingRef !== empresa.ref" aria-hidden="true"></i>
      </button>
    </li>
  </ul>

  <div class="login-error" role="alert" *ngIf="errorMessage">
    <i class="pi pi-exclamation-triangle"></i>
    <span>{{ errorMessage }}</span>
  </div>

  <div class="form-link-row">
    <a class="form-link" (click)="onVoltar()" href="javascript:void(0)">
      <i class="pi pi-arrow-left"></i> Voltar
    </a>
  </div>
</div>
